import { FC, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, styled, Typography } from "@mui/material";
import Loading from "../common/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import useNewReferenceNumber from "@/hooks/useNewReferenceNumber";

const CancelButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    top: 4,
    right: 4,
    color: 'black',
}));

interface PaymentInPersonProps 
{
    cost?: number;
    handleInPersonPaymentComplete: (clientReferenceId?: string) => void;
    handleCancel: () => void;
}

const PaymentInPerson: FC<PaymentInPersonProps> = ({
    cost,
    handleInPersonPaymentComplete,
    handleCancel
}) => {
    const {data: referenceNumber} = useNewReferenceNumber();

    const [openWarning, setOpenWarning] = useState(false);

    const handleClickOpen = () => {
        setOpenWarning(true);
      };
    
      const handleClose = () => {
        setOpenWarning(false);
      };

    const handleCancelConfirm = () => {
        setOpenWarning(false);
        handleCancel();
    }

    return (
        <>
            {
                !referenceNumber && (
                    <Loading />
                )
            }
            {
                (!!referenceNumber) && (

                    <>
                        <Dialog 
                            maxWidth="sm" 
                            open 
                            fullWidth
                            PaperProps={{
                                sx: {
                                    position: 'relative', 
                                },
                            }}
                        >
                            <CancelButton
                                onClick={handleClickOpen}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </CancelButton>

                            <Box
                                sx={{
                                    padding: 4,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 4,
                                }}
                            >
                                <Typography
                                    variant="h2"
                                >
                                    In Person Payment
                                </Typography>
                                <Typography
                                    variant="body1"
                                >
                                    Amount: <b>${cost}</b>
                                </Typography>
                                <Typography
                                    variant="body1"
                                >
                                    Please use reference number <b>{referenceNumber}</b> in the Stripe App.
                                </Typography>
                                

                                <Button 
                                    onClick={() => handleInPersonPaymentComplete(referenceNumber)}
                                >
                                    Payment Complete
                                </Button>
                            </Box>
                        </Dialog>
                        
                        <Dialog
                            open={openWarning}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">
                                {"Are you sure?"}
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Do not close this window if payment has been submitted and is loading on the Stripe app.
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button 
                                    onClick={handleClose}
                                >
                                    Return To Payment
                                </Button>
                                <Button 
                                    onClick={handleCancelConfirm}
                                    autoFocus
                                >
                                    Cancel Payment
                                </Button>
                            </DialogActions>
                        </Dialog>

                    </>
                    
                )
            }
        </>
    )
}

export default PaymentInPerson;